import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export function AuthCallback() {
  const { isAuthenticated, isLoading, error } = useAuth0();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (isLoading) {
      return;
    }

    const errorParam = searchParams.get("error");
    if (errorParam || error) {
      if (import.meta.env.DEV) {
        console.error("[AuthCallback] Authentication error:", errorParam || error);
      }
      navigate("/login", { replace: true });
      return;
    }

    if (isAuthenticated) {
      navigate("/applications", { replace: true });
    } else {
      navigate("/login", { replace: true });
    }
  }, [isAuthenticated, isLoading, error, navigate, searchParams]);

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <p className="text-sm text-gray-600">Completing login...</p>
      </div>
    </div>
  );
}
